/**
 * Resolves post-profile-completion redirect from WAF-safe `returnTo` tokens.
 * Pass a token → base URL map; tokens ending in `-local` require `allowLocalReturn`.
 */

export function resolveProfileCompletionRedirectUrl(
  search,
  fallbackUrl,
  { targets = {}, allowLocalReturn = false } = {},
) {
  if (!fallbackUrl) {
    return ''
  }

  const returnTo = new URLSearchParams(search).get('returnTo')
  if (!returnTo || !Object.prototype.hasOwnProperty.call(targets, returnTo)) {
    return fallbackUrl
  }

  if (returnTo.endsWith('-local') && !allowLocalReturn) {
    return fallbackUrl
  }

  return targets[returnTo] || fallbackUrl
}
